import { render, staticRenderFns } from "./imageSwiper.vue?vue&type=template&id=061ffb5a&scoped=true"
import script from "./imageSwiper.vue?vue&type=script&lang=js"
export * from "./imageSwiper.vue?vue&type=script&lang=js"
import style0 from "./imageSwiper.vue?vue&type=style&index=0&id=061ffb5a&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ffb5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('061ffb5a')) {
      api.createRecord('061ffb5a', component.options)
    } else {
      api.reload('061ffb5a', component.options)
    }
    module.hot.accept("./imageSwiper.vue?vue&type=template&id=061ffb5a&scoped=true", function () {
      api.rerender('061ffb5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/imageSwiper.vue"
export default component.exports